import React, { useState, useEffect } from "react";
import axios from "axios";
import DashboardNavigation from "./../../DashboardNavigation/DashboardNavigation";
import useScrollToTop from "./../../../hooks/useScollToTop";
import { ToastContainer, toast } from "react-toastify";
import Button from "./../../../components/Button/Button";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";
import ParrainageSection from "./ParrainageSection";

const AbonnementPage = () => {
  useScrollToTop();
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);
  const ASSO_ID = process.env.REACT_APP_ASSO_ID;

  const [abonnementData, setAbonnementData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fonction pour récupérer les requêtes depuis l'API externe
  const fetchAbonnement = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.monappliclub.com/api/subscriptions/subscriptionsByAssociation/${ASSO_ID}`
      );
      if (Array.isArray(response.data)) {
        setAbonnementData(response.data);
      } else {
        throw new Error("Les données reçues ne sont pas un tableau.");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des abonnements :", error);
      toast.error("Erreur lors de la récupération des abonnements");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAbonnement();
  }, []);

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year.slice(2)}`;
  };

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.4em] text-gray-800 text-center dark:text-white mb-4">
        ADMINISTRATEUR
      </h2>
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-widest text-gray-800 text-center dark:text-white mb-4 font-montserrat uppercase">
        Votre Abonnement à l'application
      </h2>
      <DashboardNavigation role={userRole} />
      <div className="text-center p-4 bg-blue-100 rounded-lg shadow max-w-[800px] mx-auto mb-4 dark:text-gray-800">
        <p className="text-lg font-semibold mb-2">
          Bienvenue sur la page Abonnement
        </p>
        <p className="text-sm text-left">Sur cette page, vous pouvez :</p>
        <p className="text-sm text-left">
          🔹Visualliser votre formule d'abonnement actuelle
          <br />
          🔹Afficher la période d'abonnement
          <br />
          🔹Afficher vos factures
          <br />
          🔹Renouveller votre abonnement pour une année supplémentaire
          <br />
          🔹Parrainez un club
        </p>
      </div>

      {loading ? (
        <div className="text-center my-8 text-lg font-semibold">
          Chargement...
        </div>
      ) : abonnementData.length === 0 ? (
        <div className="text-center my-8 text-sm italic">
          Aucun abonnement trouvé.
        </div>
      ) : (
        <div className="overflow-x-auto max-w-[1000px] mx-auto mt-4 mb-6 rounded-lg shadow bg-white dark:bg-gray-800">
          <table className="min-w-full text-sm text-left text-gray-700 dark:text-gray-300">
            <thead className="bg-blue-200 dark:bg-gray-700 text-xs uppercase font-bold">
              <tr>
                <th className="px-4 py-2">Produit</th>
                <th className="px-4 py-2">Montant (€)</th>
                <th className="px-4 py-2">Périodicité</th>
                <th className="px-4 py-2">Début</th>
                <th className="px-4 py-2">Fin</th>
                <th className="px-4 py-2">Statut</th>
                <th className="px-4 py-2">Facture</th>
              </tr>
            </thead>
            <tbody>
              {abonnementData.map((sub) => (
                <tr key={sub.id} className="border-b dark:border-gray-700">
                  <td className="px-4 py-2">{sub.product}</td>
                  <td className="px-4 py-2">{sub.total_amount}</td>
                  <td className="px-4 py-2">{sub.periodicity}</td>
                  <td className="px-4 py-2">{formatDate(sub.start_date)}</td>
                  <td className="px-4 py-2">{formatDate(sub.end_date)}</td>
                  <td className="px-4 py-2">{sub.status}</td>
                  <td className="px-4 py-2">
                    {sub.drive_invoice_link ? (
                      <a
                        href={sub.drive_invoice_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 underline hover:text-blue-700"
                      >
                        Voir la facture ↗
                      </a>
                    ) : (
                      <span className="italic text-gray-400">
                        Non disponible
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <ParrainageSection />

      <ToastContainer />
    </div>
  );
};

export default AbonnementPage;
